/** Meta Pixel helpers — fbq is loaded in public/index.html (786049027816332). */

export function isQuizPath(pathname) {
  return pathname === '/quiz' || pathname === '/quiz-speaker';
}

export function trackFacebookEvent(eventName, params) {
  const fire = () => {
    if (typeof window.fbq !== 'function') return false;
    if (params && Object.keys(params).length > 0) {
      window.fbq('track', eventName, params);
    } else {
      window.fbq('track', eventName);
    }
    return true;
  };

  if (fire()) return;

  let attempts = 0;
  const retry = window.setInterval(() => {
    attempts += 1;
    if (fire() || attempts >= 25) {
      window.clearInterval(retry);
    }
  }, 100);
}

export function trackQuizPageView() {
  trackFacebookEvent('PageView', { content_name: 'Speaker Quiz' });
}

export function trackQuizLeadStep() {
  trackFacebookEvent('Lead', {
    content_name: 'Speaker Quiz',
    content_category: 'quiz_step_1',
  });
}

export function trackQuizSuccess() {
  trackFacebookEvent('Lead', {
    content_name: 'Speaker Quiz Success',
    content_category: 'quiz_correct',
  });
  trackFacebookEvent('InitiateCheckout', {
    content_name: 'Early Bird 99 No Brainmapping',
    content_category: 'quiz_offer',
    value: 99,
    currency: 'EUR',
  });
}
